import { createContext as t } from "react";
const o = t(null), a = {
  activeCategory: "",
  openCategory: "",
  activeItem: "",
  focusCategory: 0,
  focusItem: -1,
  focusOnTab: !1
};
export {
  o as GlobalNavContext,
  a as defaultGlobalNavContextState
};
